import { Button, ButtonGroup, Flex } from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import type { ChartType, ChartSex } from './data'
import messages from './messages'

interface ChartControlsProps {
  chartType: ChartType
  sex: ChartSex
  onChartTypeChange: (type: ChartType) => void
  onSexChange: (sex: ChartSex) => void
}

const CHART_TYPES: Array<{ value: ChartType; messageKey: keyof typeof messages }> =
  [
    { value: 'weightForAge', messageKey: 'weightForAge' },
    { value: 'heightForAge', messageKey: 'heightForAge' },
    { value: 'bmiForAge', messageKey: 'bmiForAge' },
    { value: 'headCircumferenceForAge', messageKey: 'headCircumferenceForAge' }
  ]

export default function ChartControls({
  chartType,
  sex,
  onChartTypeChange,
  onSexChange
}: ChartControlsProps) {
  const { formatMessage } = useIntl()

  return (
    <Flex gap={4} wrap="wrap" align="center" px={8} pt={4}>
      <ButtonGroup size="sm" isAttached variant="outline">
        {CHART_TYPES.map(({ value, messageKey }) => (
          <Button
            key={value}
            isActive={chartType === value}
            onClick={() => { onChartTypeChange(value) }}
            _active={{ bg: 'blue.500', color: 'white', borderColor: 'blue.500' }}
          >
            {formatMessage(messages[messageKey])}
          </Button>
        ))}
      </ButtonGroup>

      <ButtonGroup size="sm" isAttached variant="outline">
        <Button
          isActive={sex === 'M'}
          onClick={() => { onSexChange('M') }}
          _active={{ bg: 'blue.500', color: 'white', borderColor: 'blue.500' }}
        >
          ♂ {formatMessage(messages.male)}
        </Button>
        <Button
          isActive={sex === 'F'}
          onClick={() => { onSexChange('F') }}
          _active={{ bg: 'pink.400', color: 'white', borderColor: 'pink.400' }}
        >
          ♀ {formatMessage(messages.female)}
        </Button>
      </ButtonGroup>
    </Flex>
  )
}
